import { render, staticRenderFns } from "./CompanyUsers.vue?vue&type=template&id=a2a43d96&"
import script from "./CompanyUsers.vue?vue&type=script&lang=ts&"
export * from "./CompanyUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports